module.exports = __webpack_public_path__ + "static/media/table.041a9e45.png";